import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  private readonly storageKey = 'user_permissions';

  // Store permissions in session storage
  setPermissions(data: any[]): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  // Retrieve permissions from session storage
  getPermissions(): any[] {
    const data = sessionStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : [];
  }

  /**
   * Check if user has specific permission (e.g. 'Edit') for a URL (e.g. '/master/unit')
   */
  hasPrivilege(url: string, privilegeName: string): boolean {
    const permissions = this.getPermissions();

    // Recursively search through all menus and submenus
    const findPrivilege = (menus: any[]): boolean => {
      for (const menu of menus) {
        // console.log(menu)
        if (menu.url === url && menu.privileges) {
          const privilege = menu.privileges.find(
            (p: any) => p.name.toLowerCase() === privilegeName.toLowerCase()
          );
          return privilege?.status === true;
        }
        if (menu.sub_menus?.length) {
          const found = findPrivilege(menu.sub_menus);
          // console.log(menu.sub_menus)
          if (found) return true;
        }
      }
      return false;
    };

    return findPrivilege(permissions);
  }
}
